import React from 'react'
import classNames from 'classnames'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import { FootnotesOptions } from '@toasttab/shared/src/utils/Contentful/richText'
import { GlobalBannerData } from '@toasttab/shared/src/components/organisms/Header/Banner/GlobalBanner.d'

interface FootnotesProps {
  footnotes?: any
  classes?: string
  innerContainerClasses?: string
}

const Footnotes = ({
  footnotes,
  classes = '',
  innerContainerClasses = ''
}: FootnotesProps) => {
  const { activeGlobalBanner, globalSettings, packageName, styleContext } =
    usePageContext()
  const bannerData = globalSettings?.globalBanner?.find(
    (banner: GlobalBannerData) => banner.contentful_id === activeGlobalBanner
  )

  const containerClasses = classNames(classes, {
    'bg-gray-0': styleContext !== 'request-demo',
    'bg-white': styleContext === 'request-demo',
    'pt-16': classes === ''
  })

  const borderColor =
    packageName === 'onTheLine' ? 'border-color-light' : 'border-light'

  const innerContainerCss = classNames({
    [innerContainerClasses]: innerContainerClasses,
    'ds-footer-container border-b py-4 text-xs leading-snug text-secondary':
      !innerContainerClasses,
    [borderColor]: !innerContainerClasses
  })

  return footnotes || bannerData?.footnotes?.raw ? (
    <section
      className={containerClasses}
      data-testid='Footnotes-1'
      role='doc-endnotes'
    >
      <div className={innerContainerCss}>
        {bannerData?.footnotes?.raw
          ? renderRichText(bannerData.footnotes, FootnotesOptions)
          : null}
        {footnotes ? renderRichText(footnotes, FootnotesOptions) : null}
      </div>
    </section>
  ) : null
}

export default Footnotes
